// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"454": "9b5d9f17f3de9530","757": "a24053f93b0a2ac4",}[chunkId] + ".js"
}